import React from 'react'

import styled from 'styled-components'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment'

export const Wrapper = styled.div`
  display: flex;
  font-family: ${({ theme }) => theme.fonts.regular};

  font-size: ${({ theme }) => theme.fontSize.s12};
  position: relative;
  color: ${({ theme }) => theme.colors.white};
  margin-right: 10px;
  padding: 5px 10px 5px 10px;
  height: 38px;
  width: fit-content;
  background-color: ${({ theme }) => theme.colors.gray2};
  border-radius: 3px;

  input {
    width: 132px;
    top: 5px;
    position: relative;

    background-color: transparent;
  }
  :focus {
    box-shadow: none !important;
  }

  .drp-calendar {
    font-family: ${({ theme }) => theme.fonts.regular};
    background-color: ${({ theme }) => theme.colors.gray1};
  }

  ::before {
    content: 'Date range:';
    position: absolute;
    left: 12px;
    font-size: 10px;
  }
`

export type DateRangeProps = {
  onFilterApply: (filter: { startDate: string; endDate: string }) => void
}

export const DateRangePickerComponent: React.FC<DateRangeProps> = (
  props
) => {
  const { onFilterApply } = props
  const handleApply = (event, picker) => {
    onFilterApply({
      startDate: picker.startDate.toLocaleString(),
      endDate: picker.endDate.toLocaleString(),
    })
  }

  return (
    <Wrapper {...props}>
      <DateRangePicker
        onApply={handleApply}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        initialSettings={{
          showDropdowns: true,
          timePicker: false,
          startDate: moment().startOf('hour').toDate(),
          endDate: moment().startOf('hour').add(32, 'hour').toDate(),
          locale: {
            format: 'MM/DD/YYYY',
          },
        }}
      >
        <input type="text" />
      </DateRangePicker>
    </Wrapper>
  )
}
